import React from 'react';
import {Sx} from 'app/types/common';
import {Typography} from '@mui/material';
import {BaseBilling, formatCouponValue} from 'app/components/entities/billing/base';

interface Props extends Sx {
  coupon: BaseBilling.Coupon;
}

export function CouponDetails({sx, coupon}: Props) {
  return (
    <Typography sx={sx} data-id="coupon-details" fontWeight={600}>
      Voucher value for{' '}
      <Typography
        component="span"
        variant="inherit"
        color="secondary.main"
        data-id="coupon-product"
      >
        {coupon.applies_to_display}
      </Typography>{' '}
      is{' '}
      <Typography component="span" variant="inherit" color="secondary.main" data-id="coupon-value">
        {formatCouponValue(coupon)}
      </Typography>
    </Typography>
  );
}
